import React, { useState } from "react";

import { CloseIco } from "../../../assets/customIcons";
import { FormFieldWrapper } from "../../index";
import { IconButton } from "../../IButton/IconButton/IconButton";
import classnames from "classnames";
import styles from "./SearchFormField.module.scss";
import {
  checksPresenceName,
  deleteInputName,
} from "../../../utils/helpers/input.helpers";

export interface ISearchFormFieldProps {
  className?: string;
  error?: string;
  label?: string;
  name?: string;
  type?: string;
  disabled?: boolean;
  isFocused?: boolean;
  currentValue?: string | number;
  isRequired?: boolean;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  value?: string | number;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClear?: () => void;
  onFindClick?: (e: React.MouseEvent) => void;
}

export const SearchFormField: React.FC<ISearchFormFieldProps> = ({
  className,
  name,
  type = "text",
  value,
  onChange,
  disabled = false,
  isFocused,
  onFocus,
  onBlur,
  label,
  onClear,
  onFindClick,
}) => {
  const [focus, setIsFocus] = useState(false);
  const isValue =
    type === "number" ? value > 0 || value === 0 : !!value || value === 0;

  const onInputFocus = (e) => {
    deleteInputName(e);
    setIsFocus(true);

    if (typeof onFocus === "function") {
      onFocus(e);
    }
  };

  const onInputBlur = (e) => {
    checksPresenceName(e, name);
    setIsFocus(false);

    if (typeof onBlur === "function") {
      onBlur(e);
    }
  };
  const onInputChange = (e) => {
    checksPresenceName(e, name);

    if (typeof onChange === "function") {
      onChange(e);
    }
  };
  return (
    <FormFieldWrapper
      label={label}
      value={value}
      disabled={disabled}
      isFocused={isFocused || focus || isValue}
      className={classnames(styles.textField, {
        [className]: className,
        [styles.noLabel]: !label,
      })}
    >
      <input
        className={classnames(styles.input, {
          [styles.activeInput]: (focus || isFocused || isValue) && !disabled,
          [styles.disabledInput]: disabled,
        })}
        name={name}
        type={type}
        onFocus={onInputFocus}
        onBlur={onInputBlur}
        readOnly={disabled}
        tabIndex={disabled ? -1 : 0}
        value={value}
        onChange={onInputChange}
      />
      {value ? <CloseIco className={styles.close} onClick={onClear} /> : ""}
      <IconButton
        typeIcon="search"
        className={styles.search}
        onClick={(e) => {
          if (typeof onFindClick === "function") {
            onFindClick(e);
          }
        }}
        disabled={disabled}
      />
    </FormFieldWrapper>
  );
};
